var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"container is-fluid",attrs:{"id":"app"}},[_c('router-view')],1),_c('footer-bar'),_c('overlay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }